import React from "react";
import tape from "../../../../../../assets/Tape.png";
import note from "../../../../../../assets/note.png";
import note2 from "../../../../../../assets/note2.png";
import note3 from "../../../../../../assets/note3.png";
import note4 from "../../../../../../assets/note4.png";

const StickyNote = ({ 
  text, 
  onClick, 
  style = {},
  textStyle = {},
  rotation = 0,
  colorIndex = 0 
}) => {
  // Array of note images: yellow, blue, purple, green
  const noteImages = [note, note2, note3, note4];
  const noteImage = noteImages[colorIndex % 4];

  return (
    <div
      className="absolute cursor-pointer hover:scale-105 transition-transform"
      style={{
        transform: `rotate(${rotation}deg)`,
        ...style
      }}
      onClick={onClick}
    >
      {/* Tape on top */}
      <img
        src={tape}
        alt="tape"
        className="absolute left-1/2 transform -translate-x-1/2"
        style={{
          top: -5,
          width: 40,
          height: 10,
          zIndex: 10,
        }}
        draggable={false}
      />
      
      {/* Sticky note image as background */}
      <div
        className="relative"
        style={{
          width: 99,
          height: 103,
        }}
      >
        <img
          src={noteImage}
          alt="sticky note"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          draggable={false}
        />
        
        {/* Text overlay */}
        <div
          className="absolute inset-0"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px",
            textAlign: "center",
            wordWrap: "break-word",
            fontFamily: "Figma Hand, cursive",
            fontSize: 14,
            color: "#000",
            lineHeight: 1.2,
            ...textStyle
          }}
        >
          {text}
        </div>
      </div>
    </div>
  );
};

export default StickyNote;
